export function LoadingComp({ padding = "", sizeClassName }: { padding?: string; sizeClassName?: string }) {
  const sizeClass = sizeClassName ? sizeClassName : "h-12 w-12";
  return (
    <div className={`flex justify-center w-full ${padding}`}>
      <div className={"animate-spin rounded-full  border-t-2 border-b-2 border-sf-purple " + sizeClass}></div>
    </div>
  );
}

export function LoadingCompFull() {
  return <LoadingComp padding="min-h-screen" />;
}
